import { c as _c } from "react/compiler-runtime";
import { Text, Dialog } from "@flat-ui";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { formatNumber } from "@utils/data-display";
/**
 * Render a dialog to get confirmation before sending request for a quote.
 */
export function QuoteConfirmationDialog(t0) {
  const $ = _c(11);
  const {
    selectedPackage,
    isLoading,
    onClose,
    onConfirm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginBottom: "24px",
      display: "block"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== selectedPackage.tokenAmount) {
    t2 = formatNumber(selectedPackage.tokenAmount);
    $[1] = selectedPackage.tokenAmount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Text variant="bodyM" sx={t1}>You are about to request a quote for{" "}<var><strong>{t2} {CREDITS_DISPLAY_NAME}</strong></var>.</Text>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text variant="bodyM">Are you sure you want to proceed?</Text>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isLoading || $[7] !== onClose || $[8] !== onConfirm || $[9] !== t3) {
    t5 = <Dialog open={true} title="Request a quote" onCancel={onClose} onClose={onClose} onConfirm={onConfirm} showSpinner={isLoading}>{t3}{t4}</Dialog>;
    $[6] = isLoading;
    $[7] = onClose;
    $[8] = onConfirm;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}